import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  logo: {
    display: 'block',
    width: 'auto',
    height: 30,
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return <img className={classes.logo} src="/neusix-logo.svg" alt="NeuSix" />;
};
